export const FAMILY_ADMIN_INTERFACE_FLAG = "release.family.admin_interface";
export const FAMILY_APP_MESSAGING_FLAG = "release.family.messaging";
export const FAMILY_APP_TIMELINE_FLAG = "release.family.timeline";
export const FAMILY_APP_VISITS_FLAG = "release.family.visits";
export const FAMILY_APP_MESSAGING_SEND_FLAG = "release.family.messaging_send";

export const CARE_PLANNING_INITIAL_ASSESSMENT_FLAG =
  "release.care_planning.initial_assessment";
export const CARE_PLANNING_RISK_ASSESSMENT_FLAG =
  "release.care_planning.risk_assessment";
export const CARE_PLANNING_SUPPORT_PLAN_FLAG =
  "release.care_planning.support_plan";
export const CARE_PLANNING_REVIEW_REPORTS_FLAG =
  "release.care_planning.review_reports";
export const CARE_PLANNING_NOTIFICATIONS_FLAG =
  "release.care_planning.notifications";
export const ASSESSMENT_QUESTION_NATURE_FLAG =
  "release.assessment.question_nature";
export const ROSTER_REALTIME_UPDATES_FLAG = "release.roster.realtime_updates";
export const ROSTER_LOCATION_MISMATCH_FLAG = "release.roster.location_mismatch";
export const ROSTER_DUPLICATE_VISIT_FILTER_FLAG =
  "release.roster.duplicate_visit_filter";
export const ROSTER_PERMANENT_ASSIGNMENTS_FLAG =
  "release.roster.permanent_assignments";
export const LINKED_VISIT_AUDIT_FLAG = "release.schedule_visit.linked_audit";
export const STAFF_INCOMPATIBILITY_MANAGEMENT_FLAG =
  "release.staff.incompatibility_management";
export const SERVICE_USER_ADMIN_NOTES_FLAG =
  "release.admin_notes.service_users";
export const STAFF_ADMIN_NOTES_FLAG = "release.admin_notes.staff";
export const SETTINGS_ACCESS_RESTRICTIONS_FLAG =
  "release.settings.access_restrictions";
export const INTERNAL_SUPPORT_ACCESS_FLAG = "release.internal_support_access";
export const SETTINGS_VISIT_DISCREPANCY_FLAG =
  "release.settings.visit_discrepancy";
export const FINANCE_INVOICES_FLAG = "release.finance.invoices";
export const FINANCE_MILEAGE_FLAG = "release.finance.mileage";
export const ALERT_FLAG = "release.alert";
export const REPORTS_QUARTERLY_DASHBOARD_FLAG =
  "release.reports.quarterly_dashboard";
export const REPORTS_METRIC_HELP_FLAG = "release.reports.metric_help";
export const DAILY_NOTE_TEMPLATES_FLAG = "release.daily_notes.templates";
export const TASK_MANAGEMENT_TEMPLATES_FLAG =
  "release.task_management.templates";
export const RECORDED_METADATA_VIEW_FLAG =
  "release.records.recorded_metadata_view";

/**
 * The complete client-side feature-flag vocabulary. Keeping this list in one
 * place lets the Flagsmith provider provide safe defaults and cache a complete
 * evaluated snapshot between browser sessions.
 */
export const RELEASE_FLAG_KEYS = [
  FAMILY_ADMIN_INTERFACE_FLAG,
  FAMILY_APP_MESSAGING_FLAG,
  FAMILY_APP_TIMELINE_FLAG,
  FAMILY_APP_VISITS_FLAG,
  FAMILY_APP_MESSAGING_SEND_FLAG,
  CARE_PLANNING_INITIAL_ASSESSMENT_FLAG,
  CARE_PLANNING_RISK_ASSESSMENT_FLAG,
  CARE_PLANNING_SUPPORT_PLAN_FLAG,
  CARE_PLANNING_REVIEW_REPORTS_FLAG,
  CARE_PLANNING_NOTIFICATIONS_FLAG,
  ASSESSMENT_QUESTION_NATURE_FLAG,
  ROSTER_REALTIME_UPDATES_FLAG,
  ROSTER_LOCATION_MISMATCH_FLAG,
  ROSTER_DUPLICATE_VISIT_FILTER_FLAG,
  ROSTER_PERMANENT_ASSIGNMENTS_FLAG,
  LINKED_VISIT_AUDIT_FLAG,
  STAFF_INCOMPATIBILITY_MANAGEMENT_FLAG,
  SERVICE_USER_ADMIN_NOTES_FLAG,
  STAFF_ADMIN_NOTES_FLAG,
  SETTINGS_ACCESS_RESTRICTIONS_FLAG,
  INTERNAL_SUPPORT_ACCESS_FLAG,
  SETTINGS_VISIT_DISCREPANCY_FLAG,
  FINANCE_INVOICES_FLAG,
  FINANCE_MILEAGE_FLAG,
  ALERT_FLAG,
  REPORTS_QUARTERLY_DASHBOARD_FLAG,
  REPORTS_METRIC_HELP_FLAG,
  DAILY_NOTE_TEMPLATES_FLAG,
  TASK_MANAGEMENT_TEMPLATES_FLAG,
  RECORDED_METADATA_VIEW_FLAG,
] as const;

const ROUTE_FEATURE_FLAG_PREFIXES: Array<{
  prefix: string;
  flagKey: string;
  redirectTo: string;
  fallbackEnabledWhenMissing?: boolean;
}> = [
  {
    prefix: "/service/care-planning/initial-assessment",
    flagKey: CARE_PLANNING_INITIAL_ASSESSMENT_FLAG,
    redirectTo: "/service/service-user",
  },
  {
    prefix: "/service/care-planning/risk-assessments",
    flagKey: CARE_PLANNING_RISK_ASSESSMENT_FLAG,
    redirectTo: "/service/service-user",
  },
  {
    prefix: "/service/care-planning/support-plan",
    flagKey: CARE_PLANNING_SUPPORT_PLAN_FLAG,
    redirectTo: "/service/service-user",
  },
  {
    prefix: "/service/care-planning/report",
    flagKey: CARE_PLANNING_REVIEW_REPORTS_FLAG,
    redirectTo: "/service/service-user",
  },
  {
    prefix: "/service/incompatibility",
    flagKey: STAFF_INCOMPATIBILITY_MANAGEMENT_FLAG,
    redirectTo: "/service/service-user",
  },
  {
    prefix: "/service/admin-notes",
    flagKey: SERVICE_USER_ADMIN_NOTES_FLAG,
    redirectTo: "/service/service-user",
  },
  {
    prefix: "/service/schedule-visit/audit",
    flagKey: LINKED_VISIT_AUDIT_FLAG,
    redirectTo: "/service/schedule-visit",
  },
  {
    prefix: "/staff/admin-notes",
    flagKey: STAFF_ADMIN_NOTES_FLAG,
    redirectTo: "/staff/staff-members",
  },
  {
    prefix: "/service/family-app",
    flagKey: FAMILY_ADMIN_INTERFACE_FLAG,
    redirectTo: "/service/service-user",
  },
  {
    prefix: "/service/family-access",
    flagKey: FAMILY_ADMIN_INTERFACE_FLAG,
    redirectTo: "/service/service-user",
  },
  {
    prefix: "/profile/toggle-alerts",
    flagKey: ROSTER_LOCATION_MISMATCH_FLAG,
    redirectTo: "/dashboard",
  },
  {
    prefix: "/profile/access-restrictions",
    flagKey: SETTINGS_ACCESS_RESTRICTIONS_FLAG,
    redirectTo: "/dashboard",
  },
  {
    prefix: "/profile/visit-discrepancy",
    flagKey: SETTINGS_VISIT_DISCREPANCY_FLAG,
    redirectTo: "/dashboard",
  },
  {
    prefix: "/reports/quarterly",
    flagKey: REPORTS_QUARTERLY_DASHBOARD_FLAG,
    redirectTo: "/dashboard",
  },
  {
    prefix: "/reports",
    flagKey: CARE_PLANNING_REVIEW_REPORTS_FLAG,
    redirectTo: "/dashboard",
  },
  {
    prefix: "/finance/mileage-groups",
    flagKey: FINANCE_MILEAGE_FLAG,
    redirectTo: "/finance/invoices",
  },
  {
    prefix: "/finance/mileage-settings",
    flagKey: FINANCE_MILEAGE_FLAG,
    redirectTo: "/finance/invoices",
  },
  {
    prefix: "/finance/mileage",
    flagKey: FINANCE_MILEAGE_FLAG,
    redirectTo: "/finance/invoices",
  },
  {
    prefix: "/finance",
    flagKey: FINANCE_INVOICES_FLAG,
    redirectTo: "/dashboard",
  },
  {
    prefix: "/alert",
    flagKey: ALERT_FLAG,
    redirectTo: "/dashboard",
  },
  {
    prefix: "/dailyNote/templates",
    flagKey: DAILY_NOTE_TEMPLATES_FLAG,
    redirectTo: "/dailyNote",
  },
  {
    prefix: "/tasks-management/templates",
    flagKey: TASK_MANAGEMENT_TEMPLATES_FLAG,
    redirectTo: "/tasks-management",
  },
];

export const getFeatureFlagRouteConfig = (pathname: string) => {
  const normalizedPath = pathname.split("?")[0];
  return (
    ROUTE_FEATURE_FLAG_PREFIXES.find(({ prefix }) =>
      normalizedPath.startsWith(prefix)
    ) ?? null
  );
};
